module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fetchMergeAll":"Fetch All & Merge","merged":"Merged","title":"Reviews","search":"Search"}}')
  delete Component.options._Ctor
}
